/**
 * Pending node task definitions.
 */
export interface PendingNodeTask {
  /** Canvas ID */
  nodeGraphId: string;
  /** Node ID */
  nodeId: string;
  /** Model identifier */
  modelKey: string;
  /** Backend task/request ID */
  taskId: string;
  /** Created timestamp (ms) */
  createdAt: number;
  /** Last update timestamp (ms) */
  updatedAt: number;
  /** Status polling URL */
  statusUrl?: string;
  /** Execution ID */
  executionId?: string;
}

/** LocalStorage key for pending node tasks */
export const PENDING_NODE_TASKS_KEY = 'iart:pending-node-tasks';

/** TTL for pending tasks (24h) */
export const PENDING_TASK_TTL_MS = 24 * 60 * 60 * 1000;
